const index = {
    state: {
        cart: [],
        count: 0,
        total: 0,
        items: [],
        filtered_items: [],
        lease: false,
        selected_lease: null,
        additional_items: [],
        view_count: 0
    },

    mutations: {
        update_view_count(state, payload) {
            state.view_count = payload;
        },
        update_items(state, payload) {
            state.items = payload;
            state.filtered_items = payload;
        },
        update_filtered_items(state, payload) {
            state.filtered_items = state.items.filter(item => item.name.toLowerCase().includes(payload.toLowerCase())
                || item.product_name.toLowerCase().includes(payload.toLowerCase())
            );
            let additional = state.additional_items.filter(item => item.name.toLowerCase().includes(payload.toLowerCase())
                || item.product_name.toLowerCase().includes(payload.toLowerCase())
            );
            if (additional) {
                state.filtered_items.push(...additional);
            }
        },
        update_item_quantity(state, payload) {
            state.filtered_items.find(item => item.id === payload.id).quantity = payload.quantity;
        },
        update_additional_items(state, payload) {
            if (payload) {
                state.items.push(...payload);
            }
        },
        update_cart(state, payload) {
            let findIdx = state.cart.findIndex(item => item.id === payload.id);
            if (findIdx === -1) {
                payload.quantity = 1;
                state.cart.push(payload);
            } else {
                if (!state.cart[findIdx].product_type_id_tree.includes(100)) {
                    state.cart[findIdx].quantity ++;
                }
            }
        },
        remove_from_cart(state, payload) {
            let idx = state.cart.findIndex(item => item.id === payload.id);
            state.cart.splice (idx, 1);
        },
        update_count(state) {
            let total = 0;
            state.cart.forEach(item => {
                if (!item.quantity) item.quantity = 1;
                for (let i = 0; i < item.quantity; i++) {
                    total ++;
                }
            });
            state.count = total;
        },
        update_total(state) {
            let total = 0;
            state.cart.forEach(item => {
                if (!item.quantity) item.quantity = 1;
                for (let i = 0; i < item.quantity; i++) {
                    total += parseInt(item.offer_rate);
                }
            });
            state.total = total;
        }
    },

    actions: {}
}

export default index;

